import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from './../components/components.module';
import { SchedulingapprovalPage } from './schedulingapproval.page';

const routes: Routes = [
  {
    path: '',
    component: SchedulingapprovalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    RouterModule.forChild(routes)
  ],
  declarations: [SchedulingapprovalPage]
})
export class SchedulingapprovalPageModule {}
